import { jsx as _jsx } from "react/jsx-runtime";
import { getCategoriasContasBancarias } from './categorias_contas_bancarias_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function CategoriasContasBancariasListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.CATEGORIAS_CONTAS_BANCARIAS, paginaPermissao: FUNCIONALIDADES.CATEGORIAS_CONTAS_BANCARIAS, rota: ROUTES.CATEGORIAS_CONTAS_BANCARIAS, fetchData: function (str, _, pag) { return getCategoriasContasBancarias(str, pag); }, columns: COLUNAS }));
}
export default CategoriasContasBancariasListar;
